import React from 'react'

import { chatDefinitions } from '../../../../../Chat/blocs/chatVisibility'
import WebinarsChatMessageComponent from '../../../../components/WebinarsChatMessageComponent/WebinarsChatMessageComponent'
import WebinarInfoSidebarComponent from '../../../../components/WebinarInfoSidebarComponent/WebinarInfoSidebarComponent'
import useFeatures from '../../../../hooks/useFeatures'
import { CommentsFeature } from '../../..'
import { useWebinarColors } from '../../../../hooks/useWebinarColors'

const renderSingleChatComment = (
  commentOpts: any, // TODO: type this
  HasWebinarChatLinksEnabled: boolean
) => {
  if (commentOpts.item.comment_id === 'infoPanel') {
    return <WebinarInfoSidebarComponent />
  }

  const { name, content, content_text, label } = commentOpts.item
  const isSpeaker = label === 'Speaker'
  const message =
    HasWebinarChatLinksEnabled && isSpeaker ? content : content_text

  return (
    <WebinarsChatMessageComponent
      name={name}
      message={message}
      isSpeaker={isSpeaker}
    />
  )
}

interface AudienceChatPaneProps {
  token: string
  uuid: string
  canPostChat: boolean
  styles: Record<
    | 'inputStyle'
    | 'buttonStyle'
    | 'secondaryButtonStyle'
    | 'progressBarStyles'
    | 'radioButtonStyles',
    Record<string, string>
  >
}

const AudienceChatPaneComponent = ({
  token,
  uuid,
  canPostChat,
  styles,
}: AudienceChatPaneProps) => {
  const webinarColors = useWebinarColors()
  const { HasWebinarChatLinksEnabled } = useFeatures()

  const audienceChat = chatDefinitions.chat

  return (
    <div className="comments-wrapper comments-type-chat">
      <CommentsFeature
        key="chat"
        token={token}
        uuid={uuid}
        style={{
          color: webinarColors.tabs.highContrast.color,
          backgroundColor: webinarColors.tabs.color,
        }}
        styles={styles}
        canDelete={false}
        isAutoResizeTextarea
        renderListOnTop
        namespace="webinar-sidebar-chat"
        commentType="chat"
        canPost={canPostChat}
        includeBotGreeting={audienceChat.includeBotGreeting}
        chatRoom="chat"
        injectFirstMessageId="infoPanel"
        renderSingleComment={(opts: any) =>
          renderSingleChatComment(opts, HasWebinarChatLinksEnabled)
        }
        isSelected
      />
    </div>
  )
}

export default AudienceChatPaneComponent
